// Map Supabase / network auth errors to clean, translated user-facing messages.
const PATTERNS = [
  { match: /invalid login|invalid credentials|invalid email or password/i, key: 'err.invalid_credentials' },
  { match: /email not confirmed|not confirmed/i, key: 'err.email_not_confirmed' },
  { match: /user already registered|already registered|already exists/i, key: 'err.user_exists' },
  { match: /password should be at least|password.*short|weak password/i, key: 'err.weak_password' },
  // IMPORTANT: link-related errors must match BEFORE the generic "email.*invalid"
  { match: /(email|otp|magic)\s*link.*(invalid|expired)|link.*(invalid|expired)|token.*expired|expired.*token|otp.*expired|jwt expired/i, key: 'err.expired' },
  { match: /invalid email|email.*invalid/i, key: 'err.invalid_email' },
  { match: /rate limit|too many|too frequent/i, key: 'err.rate_limit' },
  { match: /network|failed to fetch|networkerror|fetch.*failed/i, key: 'err.network' },
  { match: /body is disturbed|body.*locked|body stream/i, key: 'err.invalid_credentials' },
  { match: /captcha/i, key: 'err.captcha' },
  { match: /user not found|no user/i, key: 'err.user_not_found' },
];

const MESSAGES = {
  fr: {
    'err.invalid_credentials': 'Courriel ou mot de passe incorrect.',
    'err.email_not_confirmed': 'Courriel non confirmé. Vérifiez votre boîte de réception.',
    'err.user_exists': 'Un compte existe déjà avec ce courriel.',
    'err.weak_password': 'Le mot de passe doit contenir au moins 6 caractères.',
    'err.invalid_email': 'Adresse courriel invalide.',
    'err.rate_limit': 'Trop de tentatives. Réessayez dans quelques minutes.',
    'err.expired': 'Le lien a expiré. Demandez-en un nouveau.',
    'err.network': 'Pas de connexion internet. Vérifiez votre réseau.',
    'err.captcha': 'Vérification de sécurité requise.',
    'err.user_not_found': 'Aucun compte trouvé avec ce courriel.',
    'err.generic': 'Une erreur est survenue. Réessayez.',
  },
  en: {
    'err.invalid_credentials': 'Wrong email or password.',
    'err.email_not_confirmed': 'Email not confirmed. Check your inbox.',
    'err.user_exists': 'An account already exists with this email.',
    'err.weak_password': 'Password must be at least 6 characters.',
    'err.invalid_email': 'Invalid email address.',
    'err.rate_limit': 'Too many attempts. Try again in a few minutes.',
    'err.expired': 'The link has expired. Request a new one.',
    'err.network': 'No internet connection. Check your network.',
    'err.captcha': 'Security verification required.',
    'err.user_not_found': 'No account found with this email.',
    'err.generic': 'Something went wrong. Please try again.',
  },
};

export function humanizeAuthError(error, lang = 'fr') {
  if (!error) return '';
  const raw = (error.message || error.error_description || String(error) || '').trim();
  const dict = MESSAGES[lang] || MESSAGES.fr;
  for (const p of PATTERNS) {
    if (p.match.test(raw)) return dict[p.key];
  }
  return dict['err.generic'];
}
